import * as yup from 'yup';

export const initialValues = {
  roleName: '',
  isActive: '',
  privilegeIds: [],
};

export const validationSchema = yup.object().shape({
  roleName: yup.string().required('Role Name is required'),
  isActive: yup.string().required('Status is required'),
  privilegeIds: yup
    .array()
    .of(
      yup.object().shape({
        status: yup.boolean(),
      }),
    )
    .test(
      'at-least-one-on',
      'At least one privilege must be enabled',
      value => value && value.some(v => v.status),
    )
    .required('Privileges are required'),
});
